import i18n from '../i18n'
import store from '../store'

const DashboardLayout = () => import('../layouts/dashboard/DashboardLayout.vue')
const HomepageLayout = () => import('../layouts/HomepageLayout.vue')
const MembershipLayout = () => import('../layouts/MembershipLayout.vue')
const ErrorPageLayout = () => import('../layouts/ErrorPageLayout.vue')
// const Dashboard = () => import('../views/Dashboard.vue')
const Login = () => import('../views/user/Login.vue')
const ForgotPassword = () => import('../views/user/ForgotPassword.vue')
const ResetPassword = () => import('../views/user/ResetPassword.vue')
const SignUp = () => import('../views/user/SignUp.vue')
const VerifyEmail = () => import('../views/user/VerifyEmail.vue')
const Payment = () => import('../views/user/Payment.vue')
const PaymentSuccess = () => import('../views/user/PaymentSuccess.vue')
const NotFound = () => import('../views/error/NotFound.vue')
const NotAllowed = () => import('../views/error/NotAllowed.vue')
const Profile = () => import('../views/user/Profile.vue')
const Settings = () => import('../views/user/Settings.vue')
const Home = () => import('../views/home/Home.vue')
const Pricing = () => import('../views/home/Pricing.vue')
const Catalog = () => import('../views/home/Catalog.vue')
const WhoWeAre = () => import('../views/home/WhoWeAre.vue')
const Contact = () => import('../views/home/Contact.vue')
const HowToRun = () => import('../views/home/HowToRun.vue')
const LegalInformation = () => import('../views/home/LegalInformation.vue')
const Definitions = () => import('../views/home/Definitions.vue')
const OnlineInternalAudit = () => import('../views/home/OnlineInternalAudit.vue')
// const ComingSoon = () => import('../views/home/ComingSoon.vue');
const Process = () => import('../views/process/Process.vue')
const ScoreboardReport = () => import('../views/report/ScoreboardReport.vue')
const QuestionAnswerReport = () => import('../views/report/QuestionAnswerReport.vue')
const HistoricalReport = () => import('../views/report/HistoricalReport.vue')
const AdminProcess = () => import('../views/admin/process/Process.vue')
const AdminProcessQuestion = () => import('../views/admin/process/question/Question.vue')
const AdminReportExport = () => import('../views/admin/report/Export.vue')
const AdminCompany = () => import('../views/admin/company/Company.vue')
const AdminUser = () => import('../views/admin/user/User.vue')
const AdminDiscount = () => import('../views/admin/discount/Discount.vue')
const CompanyAnswerCompareReport = () => import('../views/report/CompanyAnswerCompare.vue')
const CompanyScoreCompareReport = () => import('../views/report/CompanyScoreCompare.vue')
const CompanyDepartment = () => import('../views/admin/companyDepartment/CompanyDepartment.vue')

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  // next(`${i18n.t('routes.user')}/${i18n.t('routes.login')}`);
  next('/')
}

const ifAdmin = (to, from, next) => {
  if (store.getters.isAuthenticated && store.getters.role.admin) {
    next()
    return
  }
  next('/')
}
const ifCompany = (to, from, next) => {
  if (store.getters.isAuthenticated && (store.getters.role.admin || store.getters.role.company)) {
    next()
    return
  }
  next('/')
}
const ifProcessAdmin = (to, from, next) => {
  if (
    store.getters.isAuthenticated &&
    (store.getters.role.admin || store.getters.role.companyProcessCreate)
  ) {
    next()
    return
  }
  next('/')
}
const ifCompanyAdmin = (to, from, next) => {
  if (
    store.getters.isAuthenticated &&
    (store.getters.role.admin || store.getters.role.companyManagement)
  ) {
    next()
    return
  }
  next('/')
}

const routes = [
  {
    path: `/${i18n.t('routes.user')}/`,
    component: MembershipLayout,
    beforeEnter: ifNotAuthenticated,
    children: [
      {
        path: i18n.t('routes.login'),
        name: 'login',
        component: Login
      },
      {
        path: i18n.t('routes.signup'),
        name: 'signup',
        component: SignUp
      },
      {
        path: i18n.t('routes.forgotPassword'),
        name: 'forgotPassword',
        component: ForgotPassword
      },
      {
        path: i18n.t('routes.resetPassword'),
        name: 'resetPassword',
        component: ResetPassword
      },
      {
        path: i18n.t('routes.verifyEmail'),
        name: 'verifyEmail',
        component: VerifyEmail
      }
    ]
  },
  {
    path: `/${i18n.t('routes.user')}/`,
    component: MembershipLayout,
    children: [
      {
        path: i18n.t('routes.payment'),
        name: 'payment',
        component: Payment
      }
    ]
  },
  {
    path: `/${i18n.t('routes.user')}/${i18n.t('routes.payment')}/${i18n.t('routes.completed')}`,
    name: 'paymentSuccess',
    component: PaymentSuccess
  },
  {
    path: '/',
    component: HomepageLayout,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      }
    ]
  },
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: i18n.t('routes.pricing'),
        name: 'pricing',
        component: Pricing
      },
      {
        path: i18n.t('routes.whoWeAre'),
        name: 'whoWeAre',
        component: WhoWeAre
      },
      {
        path: i18n.t('routes.whatIsOnlineInternalAudit'),
        name: 'onlineInternalAudit',
        component: OnlineInternalAudit
      },
      {
        path: i18n.t('routes.catalog'),
        name: 'catalog',
        component: Catalog
      },
      {
        path: i18n.t('routes.howToRun'),
        name: 'howToRun',
        component: HowToRun
      },
      {
        path: i18n.t('routes.definitions'),
        name: 'definitions',
        component: Definitions
      },
      {
        path: i18n.t('routes.legalInformation'),
        name: 'legalInformation',
        component: LegalInformation
      },
      {
        path: i18n.t('routes.contact'),
        name: 'contact',
        component: Contact
      }
    ]
  },
  {
    path: '/',
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
      // {
      //   path: i18n.t('routes.dashboard'),
      //   name: 'dashboard',
      //   component: Dashboard
      // },
      {
        path: i18n.t('routes.profile'),
        name: 'profile',
        component: Profile
      },
      {
        path: i18n.t('routes.settings'),
        name: 'settings',
        component: Settings
      },
      {
        path: i18n.t('routes.process'),
        name: 'process',
        component: Process
      },
      {
        path: `${i18n.t('routes.report')}/${i18n.t('routes.scoreboard')}`,
        name: 'reportScoreboard',
        component: ScoreboardReport
      },
      {
        path: `${i18n.t('routes.report')}/${i18n.t('routes.questionsAnswers')}`,
        name: 'reportQuestionsAnswers',
        component: QuestionAnswerReport
      },
      {
        path: `${i18n.t('routes.report')}/${i18n.t('routes.historical')}`,
        name: 'reportHistorical',
        component: HistoricalReport
      },
      {
        path: `${i18n.t('routes.report')}/${i18n.t('routes.company')}/${i18n.t(
          'routes.answerCompare'
        )}`,
        name: 'reportCompanyAnswerCompare',
        beforeEnter: ifCompany,
        component: CompanyAnswerCompareReport
      },
      {
        path: `${i18n.t('routes.report')}/${i18n.t('routes.company')}/${i18n.t(
          'routes.scoreCompare'
        )}`,
        name: 'reportCompanyScoreCompare',
        beforeEnter: ifCompany,
        component: CompanyScoreCompareReport
      },
      {
        path: `${i18n.t('routes.company')}/${i18n.t('routes.department')}`,
        name: 'companyDepartment',
        beforeEnter: ifCompany,
        component: CompanyDepartment
      }
    ]
  },
  {
    path: `/${i18n.t('routes.admin')}`,
    component: DashboardLayout,
    beforeEnter: ifCompany,
    children: [
      {
        path: i18n.t('routes.process'),
        name: 'adminProcess',
        component: AdminProcess,
        beforeEnter: ifProcessAdmin
      },
      {
        path: `${i18n.t('routes.process')}/:processId/${i18n.t('routes.question')}`,
        name: 'adminProcessQuestion',
        component: AdminProcessQuestion,
        beforeEnter: ifProcessAdmin
      },
      {
        path: `${i18n.t('routes.report')}/${i18n.t('routes.export')}`,
        name: 'adminReportExport',
        component: AdminReportExport,
        beforeEnter: ifAdmin
      },
      {
        path: i18n.t('routes.company'),
        name: 'adminCompany',
        component: AdminCompany,
        beforeEnter: ifCompanyAdmin
      },
      {
        path: i18n.t('routes.userManagement'),
        name: 'adminUser',
        component: AdminUser,
        beforeEnter: ifAdmin
      },
      {
        path: i18n.t('routes.discount'),
        name: 'adminDiscount',
        component: AdminDiscount,
        beforeEnter: ifAdmin
      }
    ]
  },
  {
    path: `/${i18n.t('routes.error')}/`,
    component: ErrorPageLayout,
    children: [
      {
        path: i18n.t('routes.notAllowed'),
        name: 'notAllowed',
        component: NotAllowed
      }
    ]
  },
  {
    path: '*',
    component: ErrorPageLayout,
    children: [
      {
        path: '',
        name: 'notFound',
        component: NotFound
      }
    ]
  }

  // {
  //   path: `/${i18n.t('routes.comingSoon')}`,
  //   name: 'comingSoon',
  //   component: ComingSoon,
  // },
]

export default routes
